/// <amd-module name="Environments/EnvironmentTraceabilityChanges/Components/CommitViewComponent" />
import React = require("react");
import { Components, IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { ICommitViewChangesData, ICommitViewService } from "Environments/EnvironmentTraceabilityChanges/Common/CommitViewService.types";
import { Change, IArtifactServerObject, ITraceabilityCardProps } from "Traceability/Changes/Types";
import { ChangesCard } from "Traceability/Changes/ChangesCard";
import { Page } from "VSSUI/Page";
import { Surface, SurfaceBackground } from "VSSUI/Surface";
import { Utilities } from "Traceability/Common/Utilities";
import { getAssetLocation } from "VSS/Platform/Location";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";
import { Card } from "VSSUI/Card";
import { ZeroData } from "VSSUI/ZeroData";
import * as Resources from "Environments/EnvironmentTraceabilityChanges/Resources";

class CommitViewComponent extends VssComponent {
    public constructor(props: {}, context: IVssComponentContext) {
        super(props, context);
        this._service = this.context.pageContext.getService<ICommitViewService>("ICommitViewChangesService");
    }

    public render(): JSX.Element {
        const pageData = this._service.pageData;
        if(pageData && pageData.artifactsData && pageData.artifactsData.length < 1 ){
            return this._getZeroDataContentForFilters();
        } 

        const cards = this._getChangesCards(pageData);

        return (
            <Surface background={SurfaceBackground.neutral}>
                <Page className="traceability-page">
                    <div className="page-content page-content-top">{cards}</div>
                </Page>
            </Surface>
        );
    }

    public componentDidMount(): void{
        super.componentDidMount();
        const telemetryService = this.context.pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
        const artifactsData = this._service.pageData && this._service.pageData.artifactsData || [];
        telemetryService.publishEvent("Traceability", "Environments.ChangesTab", {cardsDisplayed: artifactsData.length});
    }

    private _getChangesCards(pageData: ICommitViewChangesData): JSX.Element[] {
        let cards: JSX.Element[] = [];
        const artifactsData = pageData && pageData.artifactsData || [];
        const hideCardTitle = artifactsData.length === 1;
        (pageData && pageData.artifactsData || []).forEach((artifactData: IArtifactServerObject<Change>, index: number) => {
            const cardProps: ITraceabilityCardProps<Change> = {
                cardIndex: index,
                innerErrorMessage: artifactData.innerErrorMessage,
                artifactDetails: Utilities.getArtifactDetailsObject<Change>(artifactData, pageData.currentRunId),
                data: artifactData.data || [],
                getPipelineTypeWorkItems: false,
                getCardData: this._service.getChanges,
                hideCardTitle: hideCardTitle
            };

            cards.push(
                <div key={index} className="page-content-bottom">
                    <ChangesCard key={index} {...cardProps} />
                </div>
            );
        });

        return cards;
    }

    private _getZeroDataContentForFilters(): JSX.Element {
        const image = getAssetLocation(this.context.pageContext, "ms.vss-environments-web/environment-rundetails/Content/no-results.png");
        return (
            <Card className="flex-grow bolt-card-no-vertical-padding environment-minimum-card-height" contentProps={{ contentPadding: false }}>
                <div className="zero-data-container">
                    <ZeroData
                        imageAltText={Resources.NoChanges}
                        imagePath={image}
                        secondaryText={Resources.NoChanges}
                        className={"zero-data-content"}
                    />
                </div>
            </Card>
        )
    }

    private _service: ICommitViewService;
}

Components.add("TraceabilityCommitViewChanges", CommitViewComponent);
